import { Checklist } from '..';
import {
  ConfigurationVINNumber,
  EcomAccessoryItem,
  LeadQuotation,
  VehicleDeliveryStatus,
  VehicleRegistrationStatus,
} from './configuration';
import { Exterior, LeadCustomerDetails } from './lead';
import { Showroom } from './showroom';
import { OwnerUser } from './user';
import { VehicleModelMinimal } from './vehicleModal';
import { VehicleVariantMinimal } from './vehicleVariant';

export enum VINStatus {
  Available = 'Available',
  Reserved = 'Reserved',
  Booked = 'Booked',
  Ordered = 'Ordered',
  Invoiced = 'Invoiced',
  OrderCompleted = 'OrderCompleted',
}

export enum InventoryStatus {
  Closed = 'Closed',
  Finished = 'Finished',
  Invoiced = 'Invoiced',
  OnHire = 'OnHire',
  Ordered = 'Ordered',
  Shipped = 'Shipped',
  Stock = 'Stock',
  Transfer = 'Transfer',
}

export enum ReportInventoryStatus {
  Closed = 'Closed',
  OnHire = 'OnHire',
  PreVin = 'PreVin',
  Produced = 'Produced',
  Shipped = 'Shipped',
  Stock = 'Stock',
  Transfer = 'Transfer',
}

export enum ProgressCode {
  Available = 'Available',
  Cannibalised = 'Cannibalised',
  Closed = 'Closed',
  Demo = 'Demo',
  Finished = 'Finished',
  Invoiced = 'Invoiced',
  Memorandum = 'Memorandum',
  Ordered = 'Ordered',
  Promotion = 'Promotion',
  Reserved = 'Reserved',
}

export enum VehicleSalesStatus {
  Available = 'Available',
  Reserved = 'Reserved',
  Booked = 'Booked',
  Invoiced = 'Invoiced',
  Ordered = 'Ordered',
  OrderConfirmed = 'OrderConfirmed',
}

export enum ReportSalesStatus {
  Available = 'Available',
  Reserved = 'Reserved',
  Booked = 'Booked',
  ConfirmedSale = 'Confirmed Sale',
}

export enum SalesStatus {
  Available = 'Available',
  Reserved = 'Reserved',
  Booked = 'Booked',
  Invoiced = 'Invoiced',
  ConfirmedSale = 'Confirmed Sale',
}

export enum VehicleStatus {
  Accessorized = 'Accessorized',
  Available = 'Available',
  Cannibalized = 'Cannibalized',
  DamagedAlghanim = 'Damaged Alghanim',
  DamagedFranchise = 'Damaged Franchise',
  Demo = 'Demo',
  Display = 'Display',
  Hidden = 'Hidden',
  Marketing = 'Marketing',
  MissingFeatures = 'Missing Features',
  SpecialRequest = 'SpecialRequest',
  Invisible = 'Invisible',
}

export enum PreVehicleStatus {
  Available = 'Available',
  Hidden = 'Hidden',
}

export enum PreVinType {
  PreVin = 'PreVin',
  Produced = 'Produced',
}

export interface Vehicle {
  _id?: string;
  batchId?: string;
  vehicleModel: VehicleModelMinimal;
  vehicleVariant: VehicleVariantMinimal;
  isDeleted: boolean;
  isActive: boolean;
  displayName: string;
  sku: string;
  vsbNumber: string;
  basePrice: number;
  color: string;
  showroomId: string;
  showroom: Showroom;
  sellShowroom: Showroom;
  locationCode: string;
  createdAt: Date;
  updatedAt: Date;
  ecomId: string;
  exterior: Exterior;
  interior: Exterior;
  name: string;
  status: VINStatus;
  vinNumber: string;
  receiveDate: string | Date;
  invoiceDate: string | Date;
  autolineStatus: InventoryStatus;
  progressCode: ProgressCode;
  salesStatus: VehicleSalesStatus;
  quotation?: LeadQuotation;
  vinSelection?: ConfigurationVINNumber;
  leadId?: string;
  configurationId?: string;
  salesPerson?: OwnerUser;
  customer?: LeadCustomerDetails;
  quotationTotalPrice?: number;
  quotationTotalAmountPaid?: number;
  xco: string;
  ecomInventoryStatus: string;
  offerPrice?: number;
  priceFrom?: string;
  priceTo?: string;
  salesPrice?: number;
  bookingAmount?: number;
  fuel?: string;
  year: string;
  transmission?: string;
  driveType?: string;
  autolineProgressCode: ProgressCode;
  vinReservedAt?: Date;
  vinReservataionExpiryAt?: Date;
  expectedReceiveDate: Date;
  vehicleStatus?: VehicleStatus[];
  vehicleStatusComment?: string;
  lastVehicleStatusChangedBy?: OwnerUser;
  reservedAt?: string | Date;
  bookedAt?: string | Date;
  orderedAt?: string | Date;
  availableFrom?: string | Date;
  orderConfirmedAt?: string | Date;
  isPreVin?: boolean;
  preVin?: string;
  preVinIndex?: number;
  approvedBy?: OwnerUser;
  requestedBy?: OwnerUser;
  stype?: string;
  lastChangedDate?: string | Date;
  lastChangedTime?: string;
  lastChangedBy?: string;
  salesManId?: string;
  selllocn?: string;
  orderStatus?: string;
  deliveryStatus?: VehicleDeliveryStatus;
  registrationStatus?: VehicleRegistrationStatus;
  preFitAccessoriesIds?: string[];
  preFitaccessories?: EcomAccessoryItem[];
  saleDate: string | Date;
  shipName: string;
  checkList?: Checklist[];
  isTraderVin: boolean;
  gmReportedDate?: Date;
  registrationDeadline?: Date;
}

export interface TestDriveVehicle {
  _id: string;
  name: string;
  year: string;
  vehicleMagicNo: string;
  vehicleType?: string;
  genericColor?: string;
  vehicleVariant: VehicleVariantMinimal;
  vehicleModel: VehicleModelMinimal;
  registrationNo: string;
  fuel?: string;
  showroomId?: string;
  showroom?: { title: string; _id: string; locationCode: string };
  isActive: boolean;
  isDeleted?: boolean;
  locationCode: string;
  date?: Date;
  createdAt?: Date;
}

export interface VehicleCeilingPrice {
  _id: string;
  title: string;
  effectiveFromDate: Date;
  effectiveToDate: Date;
  ceilingPrices: { ceilingPrice: number; ecomSKU: string }[];
}

export interface VehicleModelss {
  modelName: string;
  description: string;
  modelCode: string;
  modelYear: any;
  bodytype?: string;
  imageUrl?: string;
  catalogueUrl?: string;
}

export interface VehicleVarient {
  variantCode: string;
  variantName: string;
  driveType: string;
  trimCode: string;
  colorCode: string;
  locationCode: string;
  registrationNumber: string;
  year: string;
  vehicleMagicNumber: string;
  fuel: string;
}
